module.exports = __webpack_public_path__ + "img/gos.d2fe8ba.png";